<template>
    <div>
        <img :src="imagurl" style="width:436px;height:auto" />
    </div>
</template>
<script>
export default {
    props:['imagurl'],
}
</script>